import { axiosInstance } from "../../../util/axios";
import { formatWithPlaceholders } from "../../../util/utils";

const fetchWaitedTimeReportId = ({ woNo }) => {
  const uri = formatWithPlaceholders(
    process.env.REACT_APP_CC_FETCH_WEBORDER_REPORT_ID_API_URL_PATH,
    woNo
  );
  const url = `${process.env.REACT_APP_CNC_BASE_API_URL_QA}${uri}`;
  console.log(`fetchWaitedTimeReportId = ${url}`);
  return axiosInstance.get(url, {
    headers: {
      Authorization: `bearer ${process.env.REACT_APP_CNC_HTTP_AUTH_TOKEN_QA}`,
    },
  });
};

const modifyReport = ({
  reportId,
  webOrderNo,
  pickupStoreLocation,
  customer_entry,
  customerArrivedDt,
  ccStatus
}) => {
  const body = {
    weborder_number: webOrderNo,
    pickup_store_location: pickupStoreLocation,
    customer_entry,
    customer_arrived_dt: customerArrivedDt,
    cc_status: ccStatus,
  };
  const patchUrl = `${process.env.REACT_APP_CNC_BASE_API_URL_QA}${process.env.REACT_APP_CC_MODIFY_WO_STATUS_REPORT_API_URL_PATH}/${reportId}`;
  console.log(`parseReportId patchUrl = ${patchUrl}`);
  return axiosInstance.patch(patchUrl, body, {
    headers: {
      Authorization: `bearer ${process.env.REACT_APP_CNC_HTTP_AUTH_TOKEN_QA}`,
    },
  });
};

const patchWeborderReport = async ({
  woNo,
  pickupStoreLocation,
  customer_entry,
  customerArrivedDt,
  ccStatus,
}) => {
  console.log(`patchWeborderReport = ${woNo}`);
  const parseReportId = (resp) => resp?.data?.data[0].id;
  try {
    const reportIdResp = await fetchWaitedTimeReportId({
      woNo,
      pickup_store_location: pickupStoreLocation,
    });
    console.log(
      `parseReportId reportIdResp = ${JSON.stringify(
        reportIdResp?.data?.data[0].id
      )}`
    );
    const repId = parseReportId(reportIdResp);
    console.log(`patchWeborderReport repId = ${repId}`);
    await modifyReport({
      reportId: repId,
      pickupStoreLocation,
      customer_entry,
      customerArrivedDt,
      ccStatus,
    });
  } catch (error) {
    console.log(`error = ${error.message}`);
  }
};

export default patchWeborderReport;
